import { useEffect, useState } from "react";
import '../../styles/delete-page.css';
import Loader from "../Loader/loader";

export const DeleteComponent = ({ deletePageData, id }) => {
    const [isDeleted, setIsDeleted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);


    const onDelete = () => {
        setSubmissionError(false);
        setLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND_API_ENDPOINT}/?entry_uid=${id}`, {
            method: 'DELETE',
        })
            .then(response => {
                if (response.ok) {
                    setIsDeleted(true);
                    setLoading(false);
                } else {
                    setSubmissionError(true);
                    throw new Error('Failed to delete');
                }
            })
            .catch(error => {
                setSubmissionError(true);
                console.error(error);
                // Handle error here
            });
    }

    const onPostDelete = () => {
        window.location.href = deletePageData.post_delete.button.href;
    }

    useEffect(() => {
        if (isDeleted) {
            setTimeout(() => {
                window.location.href = "/";
            }, 10000);
        }
    }, [isDeleted]);

    if (isDeleted) {
        return (
            <div className="delete-page">
                <img src={deletePageData.post_delete.emoji.url} width={"10%"} alt="delete" />
                <div className="delete-text">{deletePageData.post_delete.text}</div>
                <div className="btn primary-btn" onClick={onPostDelete}>{deletePageData.post_delete.button.title}</div>
            </div>
        );
    }

    return (
        <div className="delete-page">
            {loading && !submissionError && <Loader />}
            <img src={deletePageData.pre_delete.emoji.url} width={"10%"} alt="delete" />
            <div className="delete-text">{deletePageData.pre_delete.text}</div>
            <div className="btn primary-btn" onClick={onDelete}>{deletePageData.pre_delete.button_text}</div>
            {submissionError && <div className='form-title'>Something went Wrong!</div>}
        </div>
    );
}